import apiClient from '@/lib/axios';
import type {
  ApiResponse,
  SubcontractorDto,
  SubcontractorLookupDto,
  CreateSubcontractorFormData,
  UpdateSubcontractorFormData,
} from '../types';

/**
 * Get all subcontractors
 * @param isActive - Optional filter: true for active only, false for inactive only, undefined for all
 */
export const getSubcontractors = async (isActive?: boolean): Promise<SubcontractorDto[]> => {
  const params = isActive !== undefined ? { isActive } : undefined;
  const response = await apiClient.get<ApiResponse<SubcontractorDto[]>>('/subcontractors', {
    params,
  });
  return response.data.data;
};

/**
 * Get a single subcontractor by ID
 */
export const getSubcontractor = async (id: number): Promise<SubcontractorDto> => {
  const response = await apiClient.get<ApiResponse<SubcontractorDto>>(`/subcontractors/${id}`);
  return response.data.data;
};

/**
 * Create a new subcontractor
 */
export const createSubcontractor = async (
  data: CreateSubcontractorFormData
): Promise<SubcontractorDto> => {
  const response = await apiClient.post<ApiResponse<SubcontractorDto>>('/subcontractors', data);
  return response.data.data;
};

/**
 * Update an existing subcontractor
 */
export const updateSubcontractor = async (
  id: number,
  data: UpdateSubcontractorFormData
): Promise<SubcontractorDto> => {
  const response = await apiClient.put<ApiResponse<SubcontractorDto>>(
    `/subcontractors/${id}`,
    data
  );
  return response.data.data;
};

/**
 * Delete (soft-delete) a subcontractor
 */
export const deleteSubcontractor = async (id: number): Promise<void> => {
  await apiClient.delete(`/subcontractors/${id}`);
};

/**
 * Get active subcontractors for dropdown lookups
 */
export const getSubcontractorLookup = async (): Promise<SubcontractorLookupDto[]> => {
  const response = await apiClient.get<ApiResponse<SubcontractorLookupDto[]>>(
    '/subcontractors/lookup'
  );
  return response.data.data;
};
